import { IModalRefProps } from "@repo/core/components/layout/Modal/types";
import {
  IModalOption,
  IModalTemplateType
} from "@repo/core/components/layout/ModalTemplate/types";
import { useDimensions } from "@repo/core/hooks/useDimensions";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import { ROUTES } from "@repo/core/routes";
import { useRef, useState } from "react";

import { usePreProposal } from "../../hooks/usePreProposal";
import { useRequirePreProposalProduct } from "../../hooks/useRequirePreProposalProduct";
import { persistPreProposalAlterarDataConferencePendingOrThrow } from "../../services/persistPreProposalAlterarPending.service";
import { usePreProposalStore } from "../../store/preProposalStore";
import useToast from "@repo/core/components/core/Toast";
import { useLayoutBandeiras } from "@repo/core/hooks/useLayoutBandeiras";
import { useProposalServicePoints } from "@repo/core/hooks/useProposalServicePoints";
import { normalizeLayoutBandeirasProductParam } from "@repo/core/utils/layoutBandeiras.utils";

export const ServicePointController = () => {
  const alertModalRef = useRef<IModalRefProps>(null);

  const { back, push, replace } = useNavigation();
  const { isTabletOrWeb } = useDimensions();
  const toast = useToast();

  const { setProposalData, proposalData } = usePreProposal();

  const [selectedServicePointId, setSelectedServicePointId] = useState<
    null | string
  >(null);

  const selectedProduct = normalizeLayoutBandeirasProductParam(
    proposalData?.strProduto
  );
  const hasProduct = useRequirePreProposalProduct(selectedProduct);

  const { data: flags } = useLayoutBandeiras(selectedProduct, hasProduct);

  const { data: servicePoints, isFetching: isFetchingServicePoints } =
    useProposalServicePoints(selectedProduct, flags?.[0]?.strBandeira);

  const handleExitAndSaveDraft = () => {
    // TODO: Implement save draft
    alertModalRef.current?.close();
    replace(ROUTES.proposals);
  };

  const handleExitWithoutSaveDraft = () => {
    // TODO: Implement save draft
    alertModalRef.current?.close();
    replace(ROUTES.proposals);
  };

  const handleExitPreProposal = () => {
    alertModalRef.current?.open();
  };

  const alertOptions: IModalOption[] = [
    {
      label: "Sair e salvar rascunho",
      onPress: handleExitAndSaveDraft
    },
    {
      label: "Sair sem salvar",
      onPress: handleExitWithoutSaveDraft,
      type: IModalTemplateType.outline
    }
  ];

  const handleSelectServicePoint = (id: string) => {
    id === selectedServicePointId
      ? setSelectedServicePointId(null)
      : setSelectedServicePointId(id);
  };

  const handleOnSubmitForm = async () => {
    if (!selectedServicePointId) {
      toast.error(
        "Ponto de atendimento não selecionado",
        "Por favor, selecione um ponto de atendimento"
      );
      return;
    }

    const point = servicePoints?.find(
      (p) => p.ponto === selectedServicePointId
    );

    if (!point) {
      toast.error(
        "Ponto de atendimento não encontrado",
        "Por favor, selecione um ponto de atendimento válido"
      );
      return;
    }

    setProposalData(
      { strPontoAtendimento: point.ponto },
      { skipAlterarSync: true }
    );

    const latestSnapshot = usePreProposalStore.getState().proposalData;
    if (latestSnapshot?.lngProposta) {
      try {
        await persistPreProposalAlterarDataConferencePendingOrThrow(
          latestSnapshot
        );
      } catch {
        toast.error(
          "Erro ao salvar etapa",
          "Não foi possível sincronizar com o servidor. Tente novamente."
        );
        return;
      }
    }

    push(ROUTES.preProposalsSelectAttendant);
  };

  return {
    alertModalRef,
    alertOptions,
    handleOnSubmitForm,
    back,
    handleExitAndSaveDraft,
    handleSelectServicePoint,
    isTabletOrWeb,
    servicePoints,
    selectedServicePointId,
    handleExitPreProposal,
    isFetchingServicePoints
  };
};
